import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ReactPlayer from "react-player";

import Localization from "../../localization";
import Marquee from "../../components/marquee";
import Calendar from "./Calendar";
import Button from "../../components/button";
import { changeFaq } from "../../redux/actions/options";
import { fixExternalLinks } from "../../utils/helper";

class Classes extends Component {
    _renderSection(section, video) {
        const { locale, classesData } = this.props;

        return (
            <div
                className="bg-pink pt-40 xl:pt-100 pb-60 xl:pb-100 px-16 xl:px-50"
                key={section.key}
                id={section.key}
            >
                <div className="flex mb-30 xl:mb-40">
                    <div className="xl:w-4/12" />
                    <div className="xl:w-8/12">
                        <h1 className="font-judge font-bold text-17 xl:text-30 text-blue mb-30 xl:mb-40">
                            {section.attributes.title}
                        </h1>
                        <p className="font-bold text-30 xl:text-60 text-blue ">
                            {section.attributes.subtitle}
                        </p>
                    </div>
                </div>
                <div className="flex mb-40 xl:mb-100">
                    <div className="xl:w-6/12" />
                    <div className="xl:w-6/12">
                        <div
                            className="article-body leading-tight text-17 xl:text-23 text-blue"
                            dangerouslySetInnerHTML={{
                                __html: fixExternalLinks(
                                    section.attributes.body
                                ),
                            }}
                        />
                    </div>
                </div>
                {video && (
                    <div className="mb-120 flex justify-center w-full xl:w-7/12 mx-auto">
                        <div className="aspect-ratio-16/9 w-full relative">
                            <div className="absolute w-full h-full">
                                <ReactPlayer
                                    width="100%"
                                    height="100%"
                                    controls
                                    url={video}
                                />
                            </div>
                        </div>
                    </div>
                )}
                <Calendar selectedDate={this.props.match.params.date} />
                <div className="flex mt-40 xl:mt-60">
                    <div className="xl:w-4/12" />
                    <div className="xl:w-8/12">
                        <div className="xl:w-7/12">
                            <div
                                className="article-body text-17 text-blue whitespace-pre-wrap"
                                dangerouslySetInnerHTML={{
                                    __html: fixExternalLinks(
                                        section.attributes.footer
                                    ),
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className="xl:flex flex-col items-center mt-30 xl:mt-80">
                    <Button
                        text={Localization[locale].account.button_faqs}
                        textStyle={
                            "font-bold text-20 xl:text-23 z-10 transition hover-hover:group-hover:text-white text-blue"
                        }
                        style={"xl:w-310 mb-8 w-full"}
                        onClick={() => {
                            this.props.changeFaq(true, 3);
                        }}
                    />
                    <Button
                        text={Localization[locale].footer.terms_use}
                        url={classesData.pdf}
                        textStyle={
                            "font-bold text-20 xl:text-23 z-10 transition hover-hover:group-hover:text-white text-blue"
                        }
                        style={"xl:w-310"}
                    />
                </div>
            </div>
        );
    }

    render() {
        const { classesData } = this.props;

        if (!classesData) return <div className="h-screen" />;

        return (
            <div>
                <Marquee backgroundColor={"bg-pink"} color={"blue"} />
                {classesData.content.map((section) =>
                    this._renderSection(section, classesData.embed)
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    locale: state.app.locale,
    classesData: state.pages.classes,
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            changeFaq,
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Classes);
